import * as React from "react";

import { Add } from "@livechat/design-system-icons";
import { DesignToken, Icon, RadiusToken, ShadowToken, SpacingToken } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

interface IProps {
  firstIcon: React.ReactElement;
  secondIcon: React.ReactElement;
}

const IconWrapper: React.FC<{
  children: React.ReactElement;
}> = ({ children }) => (
  <Flex
    justifyContent="center"
    alignItems="center"
    padding={withVar(SpacingToken.Spacing1)}
    borderRadius={withVar(RadiusToken.Radius3)}
    css={{ boxShadow: withVar(ShadowToken.Float) }}
  >
    {children}
  </Flex>
);

const IconsPair: React.FC<IProps> = ({ firstIcon, secondIcon }) => (
  <Flex gap="16px">
    <IconWrapper>{firstIcon}</IconWrapper>
    <Icon source={Add} customColor={withVar(DesignToken.ContentBasicPrimary)} />
    <IconWrapper>{secondIcon}</IconWrapper>
  </Flex>
);

export default IconsPair;
